import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { ADVERT_PROMO_CAMPAIGN_SET } from 'rebook/apps/advert/constants';


export function fetchActivePromoCampaign() {
  return async (dispatch, getState) => {
    const { ssr } = getState();
    await fetchQuery('/api/promo-campaign/', { apiVersion: 5, headers: ssr.headers })
      .then(
        ({ data, resp }) => {
          if (resp.status === 200 && data) {
            const campaigns = Object.values(data.objects);
            let campaign;
            if (campaigns.length < 1) {
              return null;
            }
            for (const oneCampaign of campaigns) {
              if (oneCampaign.banner_desktop && oneCampaign.platforms.indexOf('web') > -1) {
                campaign = oneCampaign;
                break;
              }
            }
            if (!campaign) {
              return null;
            }
            dispatch(setCampaign(campaign));
          }
        },
      )
      .catch(
        ({ data, resp, error }) => {
          Raven.captureMessage('did not fetch advert campaign due to error', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              data,
              error,
            },
          });
        },
      );
  };
}

export function fetchDemoPromoCampaign(campaignId) {
  return async (dispatch, getState) => {
    const { ssr } = getState();
    const url = `/api/promo-campaign/${campaignId}/`;
    await fetchQuery(url, { apiVersion: 5, headers: ssr.headers })
      .then(
        ({ data, resp }) => {
          if (resp.status === 200 && data) {
            dispatch(setCampaign(data.objects[0]));
          }
        },
      )
      .catch(
        ({ data, resp, error }) => {
          Raven.captureMessage('did not fetch advert campaign due to error', {
            level: 'error',
            extra: {
              status: resp ? resp.status : null,
              data,
              error,
            },
          });
        },
      );
  };
}

export function setCampaign(payload) {
  return {
    type: ADVERT_PROMO_CAMPAIGN_SET,
    payload,
  };
}
